<template>
  <!-- 跑马灯轮播 -->
  <div class="swipe">
    <transition-group name="fadeIn" tag="ul">
      <li v-for="(item, index) in piclist" :style="config[index]" :key="item.id">
        <img :src="item.url" />
      </li>
    </transition-group>
    <!-- <span id="arrLeft" class="prev" @click="turnleft">
          <span type="ios-arrow-back" class="icon"></span>
        </span>
        <span id="arrRight" class="next" @click="turnright">
          <span type="ios-arrow-back" class="icon"></span>
    </span>-->
  </div>
</template>

<script>
export default {
  name: "swiper",
  props: {
    piclist: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      //文件图片配置
      config: [
        {
          position: "absolute",
          width: "3rem",
          height: "7rem",
          top: "1.5rem",
          left: ".5rem",
          opacity: 0.5,
          zIndex: 2
          // transition: "1s"
        },
        {
          position: "absolute",
          width: "5rem",
          height: "9rem",
          top: ".5rem",
          left: "1rem",
          opacity: 0.8,
          zIndex: 3
          // transition: "1s"
        },
        {
          position: "absolute",
          width: "7.5rem",
          height: "11rem",
          top: "-.5rem",
          left: "2.2rem",
          opacity: 1,
          zIndex: 4
          // transition: "1s"
        },
        {
          position: "absolute",
          width: "5rem",
          height: "9rem",
          top: ".5rem",
          right: "1rem",
          opacity: 0.8,
          zIndex: 3
          // transition: "1s"
        },
        {
          position: "absolute",
          width: "3rem",
          height: "7rem",
          top: "1.5rem",
          right: ".5rem",
          opacity: 0.5,
          zIndex: 2
          // transition: "1s"
        }
      ],
      previous: 0,
      now: Date.now()
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.turnleft();
  },
  methods: {
    /**
     * 实现点击按钮切换的动画，设置时间参数防止多次点击
     */
    // turnleft: function() {
    //   this.now = Date.now();
    //   if (this.now - this.previous > 1000) {
    //     this.config.push(this.config.shift());
    //     this.previous = this.now;
    //   }
    // },
    /**
     * 向左点击
     */
    turnleft: function() {
      setInterval(() => {
        this.config.push(this.config.shift());
      }, 2000);
    },
    /**
     * 向右点击
     */
    turnright: function() {
      this.now = Date.now();
      if (this.now - this.previous > 1000) {
        this.config.unshift(this.config.pop());
        this.previous = this.now;
      }
    }
  }
};
</script>
<style lang='less' scoped>
.swipe {
  width: 100%;
  background-color: #fff;
  position: absolute;
  bottom: 14rem;
  right: 0;
  left: 0;
  z-index: 88;
  ul {
    width: 100%;
    height: 100%;
    position: relative;
    li {
      transition: all 1s;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .fadeIn-enter-active,
    .fadeIn-leave-active {
      transition: all 1s ease;
    }
    .fadeIn-enter-active,
    .fadeIn-leave {
      opacity: 1;
    }
    .fadeIn-enter,
    .fadeIn-leave-active {
      opacity: 0;
    }
  }
  .prev,
  .next {
    // transform: translate(-50%,0);
    // background-color: #f00;
    position: absolute;
    height: 1.5rem;
    width: 1.5rem;
    border-radius: 50%;
    top: 50%;
    margin-top: -56px;
    overflow: hidden;
    text-decoration: none;
    background: #000;
    z-index: 5;
    opacity: 0.12;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    .icon {
      color: #fff;
      font-size: 30px;
    }
  }
  .prev {
    left: 0;
  }
  .next {
    right: 0;
  }
  .picleft {
    width: 400;
    top: 20;
    left: 50;
    opacity: 0.2;
    z-index: 2;
  }
  .piccenter {
    width: 800;
    top: 100;
    left: 200;
    opacity: 1;
    z-index: 4;
  }
  .picright {
    width: 400;
    top: 20;
    left: 750;
    opacity: 0.2;
    z-index: 2;
  }
}
</style>